import { Controller, useFormContext } from 'react-hook-form'
import { Info as InfoIcon } from 'react-feather'
import { Skeleton } from '@material-ui/lab'
import {
  Box,
  FormControl,
  FormControlLabel,
  FormHelperText,
  IconButton,
  Switch,
  Tooltip,
  Typography,
} from '@material-ui/core'

import constants from 'constants/index'

import useStyles from './styles'
import theme from 'theme'

import { ReactComponent as DaiStarIcon } from 'images/dai-star.svg'

const DaiControlHeader = ({ isLoading }) => {
  const classes = useStyles()

  const { control, errors, watch } = useFormContext()

  const { STATUSES } = constants.dai.solutions

  const globalValue = watch('global')

  const isGlobalEnabled = globalValue !== STATUSES.DISABLED

  const handleStatusChange = (checked) =>
    checked ? STATUSES.ENABLED : STATUSES.DISABLED

  return (
    <Box className={classes.headerBox} p={2}>
      <Box>
        <Box className={classes.titleRow}>
          <Typography variant="h5">Configurações de IA</Typography>
          <DaiStarIcon
            width={14}
            height={14}
            color={theme.palette.dai.shinyBlue}
          />
          <Box alignContent="center">
            <Tooltip title="Habilita ou desabilita todas as funcionalidades de inteligência artificial da plataforma. Caso a opção seja desabilitada, as novas ferramentas de IA lançadas posteriormente serão desabilitadas por padrão.">
              <IconButton
                size="small"
                className={classes.helpIcon}
                color="primary"
              >
                <InfoIcon size={14} />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
        <Typography variant="body2" color="textSecondary">
          Defina quais ferramentas de IA estarão habilitadas para esta
          organização ou empresa.
        </Typography>
      </Box>
      <Box display="flex" alignItems="center" flexShrink={0}>
        {isLoading ? (
          <Skeleton variant="rect" width={146} height={20} />
        ) : (
          <Controller
            as={
              <FormControl>
                <FormControlLabel
                  label={
                    <Typography variant="body2" className={classes.statusLabel}>
                      {isGlobalEnabled ? 'Ativado' : 'Desativado'}
                    </Typography>
                  }
                  labelPlacement="start"
                  className={classes.formControlLabel}
                  control={<Switch checked={isGlobalEnabled} color="primary" />}
                />
                {!!errors?.global && (
                  <FormHelperText error>
                    {errors?.global?.message}
                  </FormHelperText>
                )}
              </FormControl>
            }
            control={control}
            name="global"
            onChange={([event]) => handleStatusChange(event.target.checked)}
          />
        )}
      </Box>
    </Box>
  )
}

export default DaiControlHeader
